<template>
  <div class="moment">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">推广</BreadcrumbItem>
          <BreadcrumbItem>商机</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="展商" name="1">
          <releaseExhibitor
            ref="releaseExhibitor"
            v-if="String(showTabs) === '1'"
          />
        </TabPane>
        <TabPane label="用户" name="2">
          <releaseUser
            ref="releaseUser"
            v-if="String(showTabs) === '2'"
          />
        </TabPane>
      </Tabs>
    </div>

    <Contact />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Contact from "@components/Contact/Contact";
import releaseExhibitor from "./components/release-exhibitor.vue";
import releaseUser from "./components/release-user.vue";

export default {
  name: "exhibition-moment",
  data() {
    return {
      showTabs: "1",
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany", 
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      joinEx: "companyModule/getJoinEx",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  components: {
    Contact,
    releaseExhibitor,
    releaseUser
  },
  created() {
    if (this.query && this.query.type && this.query.type === "user") {
      this.showTabs = "2";
    }
  },
  methods: {
    ...mapActions({
      getRelease: "momentModule/getRelease",
      addRelease: "momentModule/addRelease",
      delRelease: "momentModule/delRelease",
      getWeAppSmallCode: "momentModule/getWeAppSmallCode",
      getReleaseType: "momentModule/getReleaseType"
    }),
    async init() {

    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=exhibitor`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=user`);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.moment-content {
  min-width: 1000px;
  background-color: #fff;
  margin: 30px;
}
</style>